import { shallowRef, watchEffect } from 'vue'

export function useCardInstructionsComponent(bankSlug: string, permission?: boolean) {
  const cardInstructionsComponent = shallowRef(null)

  const generateComponentName = (slug: string): string => {
    return `WidgetCardInstructions${slug
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('')}`
  }

  watchEffect(async () => {
    if (permission !== undefined && !permission) {
      cardInstructionsComponent.value = null
      return
    }

    if (!bankSlug) {
      cardInstructionsComponent.value = null
      return
    }

    const componentName = generateComponentName(bankSlug)

    try {
      const component = await import(
        `~/components/widget/card-instructions/${bankSlug}/${componentName}.vue`
      )
      cardInstructionsComponent.value = component.default
    } catch (error) {
      console.log(`Card instructions component not found for bank: ${bankSlug}`, error)
      cardInstructionsComponent.value = null
    }
  })

  return {
    cardInstructionsComponent
  }
}
